import React from "react";
import PropTypes from "prop-types";

import { isAreaPrimary, isCapacityPrimary, withInventory } from "utils/spaces";

import Area from "./Area";
import AreaPrimary from "./AreaPrimary";
import Capacity from "./Capacity";
import CapacityPrimary from "./CapacityPrimary";

const SpaceSize = (props) => {
  if (isAreaPrimary(props.spaceCategory)) {
    return <AreaPrimary {...props} />;
  }
  if (isCapacityPrimary(props.spaceCategory)) {
    return <CapacityPrimary {...props} />;
  }
  if (withInventory(props.spaceCategory)) {
    return <Capacity {...props} />;
  }

  return <Area {...props} />;
};

SpaceSize.propTypes = {
  area: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    unit: PropTypes.string,
  }),
  capacity: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    unit: PropTypes.string,
  }),
  isUnitBlack: PropTypes.bool,
  isValueBold: PropTypes.bool,
  spaceCategory: PropTypes.string,
};

SpaceSize.defaultProps = {
  spaceCategory: "other",
  isUnitBlack: true,
  isValueBold: true,
};

export default SpaceSize;
